import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import LinearProgress from '@material-ui/core/LinearProgress'

const useClasses = makeStyles({
  root: {
    height: 1,
    marginBottom: -1,
  },
})

const ListLoadingIndicator = () => {
  const classes = useClasses()

  return <LinearProgress
    classes={classes}
  />
}

export default ListLoadingIndicator
